import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CTASection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            探索更多<strong className="text-primary-500">漫画</strong>分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            无论你喜欢什么类型，这里都有属于你的漫画世界
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5 max-w-3xl mx-auto mb-10">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-5 bg-background-100 hover:bg-background-200/70 rounded-lg transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">{cat.count}部</span>
            </Link>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            浏览全部漫画 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}